import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import ResourceListItem from './ResourceListItem';
import M from 'materialize-css/dist/js/materialize';
import { TitleUI, SubtitleUI } from '../../../components/UI/LabelTitleUI';
import BackButton from '../../../components/UI/BackButton';
import ConfigurationService from '../../../services/ConfigurationService';
import * as configAction from '../../../actions/configAction';
import { translate } from '../../../utils/util';
import ConfirmModal from '../../../components/UI/ConfirmModal';
import InfiniteScrollUl from '../../../components/UI/InfiniteScrollUl';
import { Input, Button, Select } from '../../../components/UI/ComponentsUI'
import { onValueChange } from '../../../utils/handleChangeHooks';

const ResourceList = (props) => {
    const messageModal = useRef();
    const [resources, setResources] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedId, setSelectedId] = useState(undefined);
    const [instanceM, setInstanceM] = useState();
    const [sheds, setSheds] = useState([])
    const [selectedResources, setSelectedResources] = useState([])
    const [filter, setFilter] = useState({});

    useEffect(() => {
        if (props.resources?.items?.length > 0) {
            if (resources.length > 0 && currentPage === 0) {
                setResources(props.resources.items);
            } else {
                setResources((prevState) => ([...prevState, ...props.resources.items]));
            }
        } else {
            setResources([]);
        }
        // eslint-disable-next-line
    }, [props?.resources?.items]);

    useEffect(() => {
        if (props.filters) {
            setFilter(props.filters)
            getResources(props.filters)
        }
        else {
            searchResources()
        }
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        props.getPrints(props.user.vision, {});
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (props.sheds) {
            const unique = [...new Set(props.sheds.map(item => item.areaId))];
            setSheds(unique.map((i) => { return { id: i, text: props.sheds.find((f) => f.areaId === i).text }; }));
        }
        // eslint-disable-next-line
    }, [props.sheds]);

    const searchResources = () => {
        if (currentPage > 0) {
            setCurrentPage(0)
        }
        getResources(filter)
    }

    const getResources = (selectedFilter) => {
        props.getResources(props.user.vision, {
            ...selectedFilter,
            PageSize: 20,
            PageIndex: currentPage,
            sort: 'name',
            sortDir: 'ASC'
        });

        props.setResourceFilters(filter)

        if (instanceM) {
            instanceM[1].close();
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onSelectItemChange = (item) => {
        props.setResource(item);
    };

    const openModal = (id) => {
        setSelectedId(id)
        messageModal.current.show();
    }

    const deleteResource = () => {
        props.deleteResource(selectedId, () => {
            messageModal.current.close();
            window.scrollTo(0, 0);
            if (currentPage > 0) {
                setCurrentPage(0)
            }
            setResources([]);
        });
    };

    const onCheckItem = (item) => {
        let arr = [];
        Object.assign(arr, selectedResources);
        let index = selectedResources.findIndex((e) => e === item.resourceId);
        if (index === -1) {
            arr.push(item.resourceId)
        } else {
            arr.splice(index, 1);
        }
        setSelectedResources(arr)
    }

    const deleteSelectedItems = () => {
        props.deleteSelected(selectedResources, () => {
            setCurrentPage(0)
        })
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <TitleUI icon="mdi mdi-clipboard-check-outline" label={translate('menu.configuration', 'configuration')} />
                <SubtitleUI icon="mdi mdi-select-group" label={translate('menu.queue', 'configuration')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate('line-picking:linepicking.filter')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <form id="getReport" className="col s12">
                                    <div className="row">
                                        <div className="input-field padding col s12">
                                            <Input
                                                id="name"
                                                name='name'
                                                placeholder={translate('resource:name')}
                                                type="text"
                                                value={filter?.name || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                        <div className="input-field padding col s12">
                                            <Select
                                                id="shed"
                                                name="shed"
                                                display="description"
                                                value={filter?.shed || ''}
                                                change={onChange}
                                                placeHolder={`Galpão - ${translate('general:choose-one-option')}`}
                                                data={sheds}
                                            />
                                        </div>
                                        <div className="input-field padding col s12">
                                            <Input
                                                id="updateBy"
                                                name='updateBy'
                                                placeholder={translate('resource:user')}
                                                type="text"
                                                value={filter?.updateBy || ''}
                                                onChange={onChange}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </li>
                    </ul>
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button full="true" text="Buscar" onClick={() => searchResources()} />
                    </div>

                    {selectedResources.length > 0 &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button full="true" text="Excluir Selecionados" onClick={() => deleteSelectedItems()} />
                        </div>
                    }
                </div>
                {resources && resources.length > 0 ? (
                    <div className="container-fluid" style={{ marginTop: '25px', }}>
                        <div id="ListItemsResources" className="container-fluid">
                            <InfiniteScrollUl
                                page={props.resources?.totalPages}
                                current={{ currentPage, setCurrentPage }}
                                hasMore={currentPage < props.resources?.totalPages ? true : false}
                                data={
                                    resources.map((item, index) => {
                                        return (
                                            <ResourceListItem
                                                // eslint-disable-next-line react/no-array-index-key
                                                key={`oi-${index}`}
                                                route={{ pathname: '../resource/insert', state: { update: true } }}
                                                data={item}
                                                onSelectChange={() => onSelectItemChange(item)}
                                                onDelete={(id) => openModal(id)}
                                                onCheckItem={(item) => onCheckItem(item)}
                                            />
                                        );
                                    })
                                }
                            />
                        </div>
                    </div>
                ) : null}
            </div>
            <ConfirmModal
                ref={messageModal}
                id="messageModalDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={deleteResource}
                btnCancel={translate('cancel', 'general')}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        filter: state.locationReducer.filter,
        resources: state.configReducer.resources,
        sheds: state.configReducer.sheds,
        filters: state.configReducer.resourceFilters
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getResources: (vision, filter) => {
            dispatch(ConfigurationService.getResources(vision, filter));
        },
        setResource: (resource) => {
            dispatch(configAction.setResource(resource));
        },
        setResourceFilters: (filters) => {
            dispatch(configAction.setResourceFilters(filters));
        },
        getPrints: (vision, filter) => {
            dispatch(ConfigurationService.getPrints(vision, filter));
        },
        deleteResource: (resourceId, callback) => {
            dispatch(ConfigurationService.deleteResource(resourceId, callback));
        },
        deleteSelected: (selectedIds, callback) => {
            dispatch(ConfigurationService.deleteSelected(selectedIds, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ResourceList)));
